// extracted by mini-css-extract-plugin
export default {"wrap":"MenuTitle_wrap__NEeyj","logoImage":"MenuTitle_logoImage__odcyl"};